<h1 *ngIf="!showSmallTitle" class="freshpass-title pt-1 pb-3">{{properties.subscribeData.freshPass}}<sup>®</sup></h1>
<h2 *ngIf="showSmallTitle" class="freshpass-title pt-1 pb-3">{{properties.subscribeData.freshPass}}<sup>®</sup></h2>
